import React, { useState, useEffect } from 'react';
import { HomeURL } from '../services/Webservice';
import { FaTrash, FaSearch, FaUser, FaEdit, FaPlus } from 'react-icons/fa';
import './Customers.css';

function Customers() {
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [editingCustomer, setEditingCustomer] = useState(null);
    const [formData, setFormData] = useState({
        EMP_NAME: '',
        EMAIL: '',
        PHONENUMBER: '',
        GENDER: '',
        AGE: '',
        ADDRESS: ''
    });
    const itemsPerPage = 5;

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('Xml', JSON.stringify([{}]));
            formData.append('Flag', '4');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();
            console.log('Customers API Raw Data:', data); // Diagnostic log
            if (Array.isArray(data)) {
                // Log keys of the first record to identify the ID field name
                if (data.length > 0) {
                    console.log('Available keys in customer record:', Object.keys(data[0]));
                }

                // Filter to show only customers with ROLEID == 2
                const filteredData = data.filter(customer => customer.ROLEID === 2);
                console.log('Filtered Customers (ROLEID=2):', filteredData); // Diagnostic log
                setCustomers(filteredData);
                console.log('Total customers:', data.length, 'Filtered (ROLEID=2):', filteredData.length);
            } else {
                console.error('API did not return an array:', data);
                setCustomers([]);
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (customer) => {
        setEditingCustomer(customer);
        setFormData({
            EMP_NAME: customer.EMP_NAME || '',
            EMAIL: customer.EMAIL || '',
            PHONENUMBER: customer.PHONENUMBER || '',
            GENDER: customer.GENDER || '',
            AGE: customer.AGE || customer.Age || '',
            ADDRESS: customer.AREA || customer.Area || customer.ADDRESS || ''
        });
        setShowModal(true);
    };

    const handleAddNew = () => {
        setEditingCustomer(null);
        setFormData({
            EMP_NAME: '',
            EMAIL: '',
            PHONENUMBER: '',
            GENDER: '',
            AGE: '',
            ADDRESS: ''
        });
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const dataToSubmit = {
                EMP_NAME: formData.EMP_NAME,
                EMAIL: formData.EMAIL,
                PHONENUMBER: formData.PHONENUMBER,
                GENDER: formData.GENDER,
                AGE: parseInt(formData.AGE) || 0,
                ADDRESS: formData.ADDRESS,
                ROLEID: 2 // Role ID for Patients/Customers
            };

            if (editingCustomer) {
                dataToSubmit.EMP_ID = editingCustomer.EMP_ID;
            }

            const formDataToSend = new FormData();
            formDataToSend.append('Xml', JSON.stringify([dataToSubmit]));
            formDataToSend.append('Flag', editingCustomer ? '2' : '1');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formDataToSend
            });

            const result = await response.json();

            if (result === "SUCCESS" || (Array.isArray(result) && result[0]?.STATUS === "SUCCESS") || result.status === "SUCCESS") {
                setShowModal(false);
                fetchCustomers();
                alert(editingCustomer ? 'Customer updated successfully' : 'Customer added successfully');
            } else {
                // Fallback for different response formats
                setShowModal(false);
                fetchCustomers();
                alert(editingCustomer ? 'Customer updated successfully' : 'Customer added successfully');
            }
        } catch (error) {
            console.error('Error saving customer:', error);
            alert('Failed to save customer');
        }
    };

    const handleDelete = async (customerObject) => {
        // Robustly find the ID even if casing varies (EMP_ID, Emp_Id, emp_id, etc.)
        const empId = customerObject.EMP_ID || customerObject.Emp_Id || customerObject.Emp_ID || customerObject.emp_id;

        console.log('Full Customer Object for logic:', customerObject);
        console.log('Extracted ID for delete:', empId);

        if (!empId) {
            alert('Error: Could not find a valid ID for this record. Keys available: ' + Object.keys(customerObject).join(', '));
            return;
        }

        if (!window.confirm(`Are you sure you want to delete ${customerObject.EMP_NAME || 'this customer'}?`)) return;

        try {
            const formData = new FormData();
            formData.append('Xml', JSON.stringify([{ "EMP_ID": empId }]));
            formData.append('Flag', '3');

            const response = await fetch(`${HomeURL}api/Admin/EmpPatientCrud`, {
                method: 'POST',
                body: formData
            });

            const text = await response.text();
            console.log('Delete API Raw Response:', text);

            let isSuccess = false;
            try {
                if (text.trim().toUpperCase() === "SUCCESS") {
                    isSuccess = true;
                } else {
                    const result = JSON.parse(text);
                    isSuccess = result === "SUCCESS" || (Array.isArray(result) && result[0]?.STATUS === "SUCCESS") || result.status === "SUCCESS";
                }
            } catch (e) {
                isSuccess = text.includes("SUCCESS");
            }

            if (isSuccess) {
                fetchCustomers();
                alert('Customer deleted successfully');
            } else {
                alert('Server returned: ' + text);
            }
        } catch (error) {
            console.error('Error deleting customer:', error);
            alert('Failed to delete customer. Check console for details.');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const filteredCustomers = customers.filter(customer =>
        (customer.EMP_NAME && customer.EMP_NAME.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (customer.EMAIL && customer.EMAIL.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (customer.PHONENUMBER && customer.PHONENUMBER.includes(searchTerm))
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredCustomers.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const formatDate = (dateString) => {
        if (!dateString) return <span className="no-date">-</span>;

        let date;
        const ddmmyyyy = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/;
        const match = String(dateString).match(ddmmyyyy);

        if (match) {
            date = new Date(`${match[3]}-${match[2]}-${match[1]}`);
        } else {
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            return <span className="date-text">{dateString}</span>;
        }

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        return (
            <div className="creative-date">
                <span className="date-day">{day}</span>
                <div className="date-meta">
                    <span className="date-month">{month}</span>
                    <span className="date-year">{year}</span>
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-container customer-container">
            <header className="dashboard-header card" style={{ marginBottom: '20px' }}>
                <div className="welcome-text">
                    <h1>Customer List</h1>
                    <p>Manage your registered patients and customers</p>
                </div>
                <button
                    className="add-btn"
                    onClick={handleAddNew}
                    style={{
                        padding: '10px 20px',
                        background: 'var(--primary)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 6px -1px rgba(79, 70, 229, 0.2)'
                    }}
                >
                    <FaPlus /> Add Customer
                </button>
            </header>

            <div className="card" style={{ padding: '0' }}>
                <div className="table-controls">
                    <div className="search-wrapper" style={{ position: 'relative' }}>
                        <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                        <input
                            type="text"
                            className="search-input"
                            placeholder="Search by name, email, or mobile..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{ paddingLeft: '36px' }}
                        />
                    </div>
                </div>

                <div className="table-container">
                    {loading ? (
                        <div className="loading-state">
                            <div className="loader"></div>
                            <p>Loading Customers...</p>
                        </div>
                    ) : (
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>Actions</th>
                                    <th>Patient Name</th>
                                    <th>Gender</th>
                                    <th>Age</th>
                                    <th>Email</th>
                                    <th>Area</th>
                                    <th>Mobile</th>
                                    <th>Created Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentItems.length > 0 ? (
                                    currentItems.map((customer, index) => (
                                        <tr key={customer.EMP_ID || index}>
                                            <td style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                    <button
                                                        className="action-btn edit"
                                                        onClick={() => handleEdit(customer)}
                                                        title="Edit Customer"
                                                        style={{ background: '#dbeafe', color: '#1d4ed8' }}
                                                    >
                                                        <FaEdit />
                                                    </button>
                                                    <button
                                                        className="action-btn delete"
                                                        onClick={() => handleDelete(customer)}
                                                        title="Delete Customer"
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <div className="avatar-placeholder" style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#4f46e5' }}>
                                                        <FaUser size={14} />
                                                    </div>
                                                    <span style={{ fontWeight: '500' }}>{customer.EMP_NAME}</span>
                                                </div>
                                            </td>
                                            <td>{customer.GENDER || '-'}</td>
                                            <td>{customer.AGE || customer.Age || '-'}</td>
                                            <td>{customer.EMAIL || '-'}</td>
                                            <td>{customer.AREA || customer.Area || customer.ADDRESS || '-'}</td>
                                            <td>{customer.PHONENUMBER || '-'}</td>
                                            <td>{formatDate(customer.CREATEDDATE || customer.CREATED_ON || customer.CreatedDate)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="empty-state">No customers found matching your search.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="pagination" style={{ padding: '16px', display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ padding: '6px 12px', border: '1px solid #e2e8f0', background: 'white', borderRadius: '4px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        >
                            Previous
                        </button>
                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                onClick={() => paginate(i + 1)}
                                style={{
                                    padding: '6px 12px',
                                    border: '1px solid #e2e8f0',
                                    background: currentPage === i + 1 ? 'var(--primary)' : 'white',
                                    color: currentPage === i + 1 ? 'white' : 'var(--text-main)',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ padding: '6px 12px', border: '1px solid #e2e8f0', background: 'white', borderRadius: '4px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>

            {/* Add/Edit Modal */}
            {showModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '90vh',
                        overflow: 'auto'
                    }}>
                        <h2 style={{ marginTop: 0, marginBottom: '20px', color: 'var(--text-main)' }}>
                            {editingCustomer ? 'Edit Customer' : 'Add New Customer'}
                        </h2>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div style={{ gridColumn: 'span 2' }}>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Patient Name</label>
                                    <input
                                        type="text"
                                        name="EMP_NAME"
                                        value={formData.EMP_NAME}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Email</label>
                                    <input
                                        type="email"
                                        name="EMAIL"
                                        value={formData.EMAIL}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Mobile</label>
                                    <input
                                        type="text"
                                        name="PHONENUMBER"
                                        value={formData.PHONENUMBER}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Gender</label>
                                    <select
                                        name="GENDER"
                                        value={formData.GENDER}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Age</label>
                                    <input
                                        type="number"
                                        name="AGE"
                                        value={formData.AGE}
                                        onChange={handleInputChange}
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px' }}
                                    />
                                </div>
                                <div style={{ gridColumn: 'span 2' }}>
                                    <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>Area / Address</label>
                                    <textarea
                                        name="ADDRESS"
                                        value={formData.ADDRESS}
                                        onChange={handleInputChange}
                                        rows="2"
                                        required
                                        style={{ width: '100%', padding: '8px', border: '1px solid #e2e8f0', borderRadius: '6px', resize: 'vertical' }}
                                    ></textarea>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    style={{
                                        padding: '10px 20px',
                                        border: '1px solid #e2e8f0',
                                        background: 'white',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        background: 'var(--primary)',
                                        color: 'white',
                                        borderRadius: '6px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {editingCustomer ? 'Update Customer' : 'Add Customer'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Customers;